import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import LostProftFilter from './LostProftFilter';
import LostProfitTable from './LostProfitTable';

export const frozenRemedyBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'analytics',
    url: '/analytics/revaluation/invoice'
  },

  {
    label: 'lost_profit',
    active: true
  }
];

const LostProfit = () => {
  const { t } = useTranslation();
  const [tableData, setTableData] = useState(false);

  return (
    <div>
      <PageBreadcrumb items={frozenRemedyBreadcrumbItems} />
      <div>
        <h2 className="mb-5">{t('lost_profit')}</h2>

        <LostProftFilter setTableData={setTableData} />
        <LostProfitTable tableData={tableData} />
      </div>
    </div>
  );
};

export default LostProfit;
